import React from 'react';

import {
    Chart,
    Series,
    CommonSeriesSettings,
    Legend,
    ValueAxis,
    Title,
    Tooltip,
    ArgumentAxis, Label, Format
} from 'devextreme-react/chart';
import { Size } from "devextreme-react/vector-map";

const sourceLoss = [
    { value: 'noError', name: 'No' },
    { value: 'onlySilence', name: 'Only Silence' },
    { value: 'lessDuration', name: 'Less Duration' },
    { value: 'packetLoss', name: 'Packet Loss' },
    { value: 'onlyTranscript', name: 'Only Transcript' },
    { value: 'totalLoss', name: 'Total Loss' },
    { value: 'callTry', name: 'Call Try' },
    { value: 'processing', name: 'Processing' },
    { value: 'single', name: 'Single' },
    { value: 'ongoing', name: 'Ongoing' },
    { value: 'otherUser', name: 'Other User' },
    { value: 'audioLoss', name: 'Audio Loss' },
    { value: 'processingError', name: 'Processing Error' },
    { value: 'noTranscript', name: 'No Transcript' },
    { value: 'errorTranscript', name: 'Transcript Error' },
    { value: 'videoLoss', name: 'Video Loss' },
    { value: 'irretrievableCall', name: 'Irretrievable Call' },
    { value: 'msftInviteError', name: 'MSFT Invite Error' }
];

class StackedBarLoss extends React.Component {

    // (if)Filter sourceLoss list based on problemType
    //(else)if problemTypes is empty read data and all data with 0 will eliminate the source item from the list to avoid having to many entries by default
    sourceLossEditedList() {

        let tmpSourceLoss = [];

        if (this.props.problemType && this.props.problemType.length > 0) {

            sourceLoss.map(el => {
                if (this.props.problemType.map(pt => pt.toLowerCase()).includes(el.value.toLowerCase())) {
                    tmpSourceLoss.push(el);
                }
            });


        } else {
            tmpSourceLoss = sourceLoss.filter(item => {
                return this.props?.data && this.props.data.some(dataItem => dataItem[item.value] !== 0);
            });
        }

        return tmpSourceLoss;

    }

    render() {
        return (
            <Chart
                id="chart"
                ref={this.props.reference}

                dataSource={this.props.data}
                palette={this.props.palette}
            >
                <CommonSeriesSettings
                    ignoreEmptyPoints={true}
                    argumentField="time" type="stackedBar"
                />
                {this.sourceLossEditedList().map(item => (
                    <Series
                        key={item.value}
                        valueField={item.value}
                        name={item.name}
                    />
                ))}

                <ArgumentAxis
                    allowDecimals={false}
                    axisDivisionFactor={60}
                >
                    <Label>
                        <Format type="decimal" />
                    </Label>
                    <Title text="Time" />
                </ArgumentAxis>
                <ValueAxis>
                    <Title text="Calls With Problems" />
                </ValueAxis>
                <Legend
                    margin={0}
                    horizontalAlignment="center"
                    verticalAlignment="bot"
                />
                <Tooltip enabled={true} />

                <Size
                    height={this.props.size.height}
                    width={this.props.size.width}
                />
            </Chart>
        );
    }
}

export default StackedBarLoss;
